// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VoDGq","right":"styles_right__2va9t"};